import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateAdminUser$ } from "../schemas/schemas_0";
export class CreateAdminUserCommand extends command(_ep0, _mw0, "CreateAdminUser", CreateAdminUser$) {
}
